import { defineAsyncComponent } from 'vue'

// Async so each cohort ships only its shell chunk (ChatAgent stays out of the
// dialer-only path); a static seam so tests can stub the pair reliably.
export const AppShellAsync = defineAsyncComponent(() => import('./components/AppShell.vue'))
export const DialerAppShellAsync = defineAsyncComponent(() => import('./components/DialerAppShell.vue'))
